import { useEffect, useRef, useState } from "react";
import { useInView, useMotionValue, useSpring, animate } from "framer-motion";

export const Counter = ({ to, suffix = "", decimals = 0, className = "", format = "plain" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 1.6,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setVal(v),
    });
    return () => controls.stop();
  }, [inView, to]);

  const display =
    format === "comma"
      ? Math.round(val).toLocaleString()
      : val.toFixed(decimals);

  return (
    <span ref={ref} className={className}>
      {display}
      {suffix}
    </span>
  );
};
